// Synthetic global leaderboard for 67Cafe.
// No backend — we generate a deterministic pool of pretend players (seeded by today's date)
// so the numbers feel real and shift daily but never leak names.

function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const BRACKETS = [
  { id: "sprout",   name: "Sprout",   min: 0,     color: "#54D62C", emoji: "🌱", blurb: "Just planted!" },
  { id: "rookie",   name: "Rookie",   min: 300,   color: "#54A0FF", emoji: "🎈", blurb: "Getting the hang of it." },
  { id: "explorer", name: "Explorer", min: 800,   color: "#00A699", emoji: "🧭", blurb: "Trying every corner of the cafe." },
  { id: "star",     name: "Star",     min: 1500,  color: "#F368E0", emoji: "🌟", blurb: "Shining brightly!" },
  { id: "whiz",     name: "Whiz",     min: 2500,  color: "#5F27CD", emoji: "🧠", blurb: "Brainy and quick." },
  { id: "champ",    name: "Champ",    min: 4000,  color: "#FFB400", emoji: "🏆", blurb: "Trophy-level talent." },
  { id: "ace",      name: "Ace",      min: 6000,  color: "#FF9F1C", emoji: "🎖️", blurb: "The one to beat." },
  { id: "legend",   name: "Legend",   min: 9000,  color: "#FF5A5F", emoji: "👑", blurb: "Absolute royalty." },
  { id: "mythic",   name: "Mythic",   min: 15000, color: "#8B4513", emoji: "🐉", blurb: "Whispered about in the halls." },
];

export const bracketFor = (score) => {
  let current = BRACKETS[0];
  for (const b of BRACKETS) {
    if (score >= b.min) current = b;
  }
  return current;
};

export const nextBracket = (score) => {
  return BRACKETS.find((b) => score < b.min) || null;
};

// Seed the pretend pool with today's date so kids see fresh numbers daily.
const todaySeed = () => {
  const s = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  return s.split("-").reduce((a, x) => a * 31 + Number(x), 7);
};

// Returns { rank, total, rows: [{position, score, isYou}] } for a user score.
// The pool holds ~800-1000 players with an exponential distribution.
export function computeGlobalRank(userScore) {
  const rng = mulberry32(todaySeed());
  const poolSize = 800 + Math.floor(rng() * 200);
  const scores = new Array(poolSize);
  for (let i = 0; i < poolSize; i++) {
    // exponent > 1 skews toward the low end so the top brackets are rare.
    const r = rng();
    scores[i] = Math.floor(30 + Math.pow(r, 2.6) * 12000);
  }
  scores.sort((a, b) => b - a); // descending

  // Binary-search the insertion index for userScore (descending).
  let lo = 0;
  let hi = scores.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (scores[mid] > userScore) lo = mid + 1;
    else hi = mid;
  }
  const rank = lo; // 0-indexed position user would occupy
  const inserted = [...scores.slice(0, rank), userScore, ...scores.slice(rank)];
  const total = inserted.length;

  const window = 3;
  const start = Math.max(0, rank - window);
  const end = Math.min(inserted.length, rank + window + 1);
  const rows = [];
  for (let i = start; i < end; i++) {
    rows.push({ position: i + 1, score: inserted[i], isYou: i === rank });
  }
  return { rank: rank + 1, total, rows };
}
